"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../../../ControlRendererContext"));
const NextButton_1 = __importDefault(require("../NextButton"));
const PrevButton_1 = __importDefault(require("../PrevButton"));
const useContainerStyle_1 = __importDefault(require("../../../../hooks/useContainerStyle"));
const valueIsNotUndefined_1 = __importDefault(require("../../../../../typeAssertions/valueIsNotUndefined"));
const Points_1 = __importDefault(require("../Points"));
const useAppStateUpdateControlById_1 = __importDefault(require("../../../../../hooks/useAppStateUpdateControlById"));
const useAppAtomStyleFromControlStyle_1 = __importDefault(require("../../../../../hooks/useAppAtomStyleFromControlStyle"));
const useAppGetColorFromSpecification_1 = __importDefault(require("../../../../../hooks/useAppGetColorFromSpecification"));
const getNumberFromUnknownOrDefault_1 = __importDefault(require("../../../../../shared/getNumberFromUnknownOrDefault"));
const defaultColor = '#343d46';
const minVelocityToRegisterSwipe = 1;
const SwiperRendererWrapper = ({ control, parent, children, }) => {
    var _a;
    const formatedChildren = react_1.Children.toArray(children).map((component, index) => ({
        id: index.toString(),
        component,
    }));
    const childrenCount = formatedChildren.length;
    const isEmpty = childrenCount === 0;
    const currentIndex = (() => {
        const fromControlIndex = (0, getNumberFromUnknownOrDefault_1.default)(control.currentIndex, 0);
        if (fromControlIndex < 0) {
            return 0;
        }
        if (isEmpty) {
            return 0;
        }
        if (fromControlIndex < childrenCount) {
            return fromControlIndex;
        }
        return 0;
    })();
    const [layout, setLayout] = (0, react_1.useState)({
        width: 0,
        height: 0,
    });
    const { Render, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const updateControlById = (0, useAppStateUpdateControlById_1.default)();
    const isLooping = !!control.loop;
    const controlRef = (0, react_1.useRef)(control);
    controlRef.current = control;
    const setCurrentSelectedPage = (0, react_1.useCallback)((targetIndex) => {
        if (targetIndex < childrenCount
            && targetIndex >= 0
            && targetIndex !== currentIndex) {
            updateControlById({
                control: controlRef.current,
                dataToUpdate: {
                    currentIndex: targetIndex,
                },
            });
        }
    }, [currentIndex, childrenCount, updateControlById]);
    const maxIndex = Math.max(0, childrenCount - 1);
    const goToNextPage = (0, react_1.useCallback)((forceLoop) => {
        if (currentIndex < maxIndex) {
            setCurrentSelectedPage(currentIndex + 1);
        }
        else if ((isLooping || forceLoop) && currentIndex === maxIndex) {
            setCurrentSelectedPage(0);
        }
    }, [isLooping, setCurrentSelectedPage, currentIndex, maxIndex]);
    const goToPrevPage = (0, react_1.useCallback)(() => {
        if (isLooping && currentIndex <= 0) {
            setCurrentSelectedPage(maxIndex);
        }
        else {
            setCurrentSelectedPage(currentIndex - 1);
        }
    }, [isLooping, currentIndex, maxIndex, setCurrentSelectedPage]);
    const timeIntervalAutoPlay = Math.round((0, getNumberFromUnknownOrDefault_1.default)(control.autoPlay, 0));
    (0, react_1.useEffect)(() => {
        if (timeIntervalAutoPlay < 1) {
            return undefined;
        }
        const timeoutId = setTimeout(() => goToNextPage(true), timeIntervalAutoPlay * 1000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [goToNextPage, timeIntervalAutoPlay]);
    const updateCurrentPage = (0, react_1.useCallback)(({ nativeEvent: { position }, }) => {
        setCurrentSelectedPage(position);
    }, [setCurrentSelectedPage]);
    const containerStyle = (0, useContainerStyle_1.default)(control.style, parent !== null && parent !== void 0 ? parent : null);
    const getAtomStyle = (0, useAppAtomStyleFromControlStyle_1.default)();
    const computedContainerStyle = getAtomStyle(containerStyle);
    const getColor = (0, useAppGetColorFromSpecification_1.default)();
    const arrowsColor = (_a = getColor(control.arrowsColor)) !== null && _a !== void 0 ? _a : defaultColor;
    return (react_1.default.createElement(Render.View, { style: Object.assign(Object.assign({}, computedContainerStyle), { position: 'relative' }) },
        react_1.default.createElement(Render.AnimatedFlatList, { style: computedContainerStyle, onSwipeToRight: goToNextPage, onSwipeToLeft: goToPrevPage, initialScrollIndex: currentIndex, onPageSelected: updateCurrentPage, horizontal: true, controlId: control.id, data: formatedChildren, keyExtractor: (item) => item.id, showsHorizontalScrollIndicator: false, bounces: false, snapToInterval: layout.width, snapToAlignment: "start", decelerationRate: 0, renderToHardwareTextureAndroid: true, onScrollEndDrag: ({ nativeEvent: { velocity }, }) => {
                if (!(0, valueIsNotUndefined_1.default)(velocity))
                    return;
                const { x } = velocity;
                if (x > minVelocityToRegisterSwipe) {
                    goToNextPage();
                }
                else if (x < -minVelocityToRegisterSwipe) {
                    goToPrevPage();
                }
            }, contentContainerStyle: {
                width: `${100 * formatedChildren.length}%`,
            }, renderItem: ({ item }) => (react_1.default.createElement(Render.View, { style: Object.assign(Object.assign({}, computedContainerStyle), { width: layout.width, height: layout.height, maxWidth: layout.width, maxHeight: layout.height, minWidth: layout.width, minHeight: layout.height }) }, item.component)), onSetLayout: setLayout }),
        control.showPoints && (react_1.default.createElement(Points_1.default, { size: childrenCount, currentIndex: currentIndex })),
        control.showsButtons && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(PrevButton_1.default, { color: arrowsColor, onPress: goToPrevPage }),
            react_1.default.createElement(NextButton_1.default, { color: arrowsColor, onPress: goToNextPage })))));
};
exports.default = SwiperRendererWrapper;
